// pages/ServicesPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { services } from '../data/constants';
import Button from '../components/ui/Button';
import Section from '../components/layout/Section';
import ServiceItem from '../components/ServiceItem';
import { trackCtaClick } from '../utils/tracking';

const ServicesPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-20">
      <Section title="Our Expert Residential Roofing Services" bg="bg-slate-50">
        <p className="text-center text-lg text-gray-700 mb-12 max-w-3xl mx-auto">
          Lemay Roofing offers a comprehensive suite of residential roofing services in Avon Park. With over 30 years of experience, we guarantee quality workmanship and durable solutions for your home.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {services.map((service) => (
            <ServiceItem key={service.title} service={service} />
          ))}
        </div>
        <div className="text-center mt-16">
          <Button onClick={() => { trackCtaClick('/request-quote', 'Get a Free Quote for Your Project'); navigate('/request-quote'); }} variant="primary" className="text-lg">
            Get a Free Quote for Your Project
          </Button>
        </div>
      </Section>
    </div>
  );
};

export default ServicesPage;
